@if (impersonate && !centralCreateLabel && !centralEditPickup && !centralConvertPickup) {
  <div class="impersonation-container">
    <div class="warn-text">
      <i class="icon-bx-error-circle icon-size-16 mr-2" aria-hidden="true"></i>
      <span class="subtitle-small"
        >You are currently impersonating: {{ userProfile?.firstName }}
        {{ userProfile?.lastName }} of {{ userProfile?.customer?.name }}</span
      >
    </div>
    <div>
      <p-button
        variant="outlined"
        severity="contrast"
        size="small"
        id="btn-stop-impersonating"
        styleClass="text-secondary impersonation-button"
        (click)="stopImpersonation()"
      >
        <span pButtonLabel>Stop impersonating</span>
      </p-button>
    </div>
  </div>
  <div class="impersonation-border"></div>
}
